var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.61 62.45",
    fill: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2385",
    "data-name": "Group 2385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2363",
    "data-name": "Group 2363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2362",
    "data-name": "Group 2362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M34.37,31.22a1.4,1.4,0,0,0-.51-1.1L25.27,23a1.43,1.43,0,0,0-2,.19,1.38,1.38,0,0,0-.33.91v4.3H1.43A1.43,1.43,0,0,0,0,29.79v2.87a1.43,1.43,0,0,0,1.42,1.43h21.5v4.3a1.44,1.44,0,0,0,1.43,1.43,1.39,1.39,0,0,0,.91-.34l8.6-7.16A1.41,1.41,0,0,0,34.37,31.22Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2365",
    "data-name": "Group 2365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2364",
    "data-name": "Group 2364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M60.77,29.2,32.41.84a2.86,2.86,0,0,0-4,0L8.1,21.1l4.05,4L30.38,6.91,54.69,31.22,30.38,55.53,12.15,37.3,8.1,41.35,28.36,61.61a2.86,2.86,0,0,0,4,0h0L60.77,33.25a2.86,2.86,0,0,0,0-4.05Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportExcel);
export default __webpack_public_path__ + "static/media/import_excel.ee786311f279eec93b8b0c3571965681.svg";
export { ForwardRef as ReactComponent };